import { createSlice } from '@reduxjs/toolkit';
// cookies
import Cookies from 'js-cookie';
const initialState = {
  api_url: 'https://eservices.helwan.edu.eg/smartID_api',
  studentData: [],
  studentID: Cookies.get('id'),
  studentObj: {},
  formsInfo: [],
  copyrights: `جميع الحقوق محفوظه لمركز الاتصالات وتكنولوجيا المعلومات - جامعة حلوان © ${new Date().getFullYear()}`,
};
/*  { name: 'استمارة 1', value: 'استمارة الاختبار الشخصي.pdf' } */
const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setStudentData(state, action) {
      state.studentData = action.payload;
    },
    setStudentID(state, action) {
      state.studentID = action.payload;
    },
    setStudentObj(state, action) {
      state.studentObj = action.payload;
    },
    setFormsInfo(state, action) {
      state.formsInfo = action.payload;
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice;
